// extracted by mini-css-extract-plugin
module.exports = {"translationForm":"_820DEubARmA_99Zhs1ber"};